export default "__VITE_PUBLIC_ASSET__a58c65cb__"